import { Alert, AlertIcon, Box, Flex, Icon, SimpleGrid, Text, useColorModeValue } from "@chakra-ui/react";
import { useAuth } from "Providers/AuthProvider";
import { useLoading } from "Providers/LoadingProvider";
import { useEffect } from "react";
import {
    TbHome,
    TbChartLine,
    TbSnowflake,
    TbList,
    TbCalendarStats,
    TbCalendar,
    TbCloudRain,
    TbReceipt,
    TbAntenna,
    TbLock,
    TbBell,
    TbPlant,
    TbFlame,
    TbMap,
} from "react-icons/tb";
import { Link } from "react-router-dom";

function MemberHome() {
    const loading = useLoading();
    const user = useAuth().getUser();
    const cardBg = useColorModeValue("white", "gray.800");
    const textColor = useColorModeValue("gray.800", "white");

    useEffect( () => {
        loading.hide();
    });

    return (
        <Box>
            <Box
                bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                borderRadius="xl"
                p={{ base: 4, md: 5 }}
                mb={6}
                boxShadow="0 4px 15px rgba(45, 107, 63, 0.2)"
            >
                <Flex align="center" gap={3}>
                    <Flex align="center" justify="center" bg="whiteAlpha.200" borderRadius="lg" p={2}>
                        <Icon as={TbHome} color="white" boxSize={6} />
                    </Flex>
                    <Box>
                        <Text color="white" fontWeight="bold" fontSize={{ base: "lg", md: "xl" }}>
                            Área de Membros
                        </Text>
                        <Text color="whiteAlpha.800" fontSize="sm">
                            Bem-vindo, {user.name}
                        </Text>
                    </Box>
                </Flex>
            </Box>
            {
                (user.membership_until_in_days <= 7) && (
                    <Alert
                        status='warning'
                        mb={6}
                        borderRadius="xl"
                        shadow="md"
                        border="1px solid"
                        borderColor="orange.200"
                    >
                        <AlertIcon />
                            { user.membership_until_in_days <= 0 ?
                                    <>
                                        Sua assinatura expirou!
                                    </>
                                    :
                                    <>
                                        Sua assinatura irá expirar em {user.membership_until_in_days} dia(s)!
                                    </>
                            }
                            {" "}
                            Para continuar utilizando, renove sua assinatura.
                            <Link to="/members/account">
                                <Text color="blue.400" as="span" ms="5px" fontWeight="bold">
                                    Clique aqui
                                </Text>
                            </Link>
                    </Alert>
                )
            }
            <SimpleGrid w="100%" columns={{ sm: 1, md: 2, lg: 4 }} gap={4}>
                <Link to={!user.membership ? "/members/account" : "/members/reports/detailed"}>
                    <Box
                        p={6}
                        bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                        borderRadius="xl"
                        color="white"
                        opacity={!user.membership ? 0.5 : 1}
                        boxShadow="lg"
                        transition="all 0.25s ease"
                        _hover={{ transform: "translateY(-4px)", boxShadow: "xl" }}
                        h="100%"
                    >
                        <Flex justifyContent={"center"} w="100%">
                            <Icon as={!user.membership ? TbLock : TbChartLine} boxSize="2.5em" />
                        </Flex>
                        <Text w="100%" textAlign={"center"} mt={3} fontSize={"lg"} fontWeight={"semibold"}>Dados Detalhados</Text>
                        <Text w="100%" textAlign={"center"} mt={1} fontSize={"xs"} color="whiteAlpha.800">Gráficos e tabelas por período</Text>
                    </Box>
                </Link>
                <Link to={!user.membership ? "/members/account" : "/members/reports/cold"}>
                    <Box
                        p={6}
                        bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                        borderRadius="xl"
                        color="white"
                        opacity={!user.membership ? 0.5 : 1}
                        boxShadow="lg"
                        transition="all 0.25s ease"
                        _hover={{ transform: "translateY(-4px)", boxShadow: "xl" }}
                        h="100%"
                    >
                        <Flex justifyContent={"center"} w="100%">
                            <Icon as={!user.membership ? TbLock : TbSnowflake} boxSize="2.5em" />
                        </Flex>
                        <Text w="100%" textAlign={"center"} mt={3} fontSize={"lg"} fontWeight={"semibold"}>Horas Frio</Text>
                        <Text w="100%" textAlign={"center"} mt={1} fontSize={"xs"} color="whiteAlpha.800">Acumulado abaixo de temperatura</Text>
                    </Box>
                </Link>
                <Link to={!user.membership ? "/members/account" : "/members/reports/data/daily"}>
                    <Box
                        p={6}
                        bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                        borderRadius="xl"
                        color="white"
                        opacity={!user.membership ? 0.5 : 1}
                        boxShadow="lg"
                        transition="all 0.25s ease"
                        _hover={{ transform: "translateY(-4px)", boxShadow: "xl" }}
                        h="100%"
                    >
                        <Flex justifyContent={"center"} w="100%">
                            <Icon as={!user.membership ? TbLock : TbList} boxSize="2.5em" />
                        </Flex>
                        <Text w="100%" textAlign={"center"} mt={3} fontSize={"lg"} fontWeight={"semibold"}>Dados Diários</Text>
                        <Text w="100%" textAlign={"center"} mt={1} fontSize={"xs"} color="whiteAlpha.800">Registros de um dia específico</Text>
                    </Box>
                </Link>
                <Link to={!user.membership ? "/members/account" : "/members/reports/data/month"}>
                    <Box
                        p={6}
                        bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                        borderRadius="xl"
                        color="white"
                        opacity={!user.membership ? 0.5 : 1}
                        boxShadow="lg"
                        transition="all 0.25s ease"
                        _hover={{ transform: "translateY(-4px)", boxShadow: "xl" }}
                        h="100%"
                    >
                        <Flex justifyContent={"center"} w="100%">
                            <Icon as={!user.membership ? TbLock : TbCalendarStats} boxSize="2.5em" />
                        </Flex>
                        <Text w="100%" textAlign={"center"} mt={3} fontSize={"lg"} fontWeight={"semibold"}>Relatório Mensal</Text>
                        <Text w="100%" textAlign={"center"} mt={1} fontSize={"xs"} color="whiteAlpha.800">Resumo completo do mês</Text>
                    </Box>
                </Link>
                <Link to={!user.membership ? "/members/account" : "/members/reports/data/year"}>
                    <Box
                        p={6}
                        bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                        borderRadius="xl"
                        color="white"
                        opacity={!user.membership ? 0.5 : 1}
                        boxShadow="lg"
                        transition="all 0.25s ease"
                        _hover={{ transform: "translateY(-4px)", boxShadow: "xl" }}
                        h="100%"
                    >
                        <Flex justifyContent={"center"} w="100%">
                            <Icon as={!user.membership ? TbLock : TbCalendar} boxSize="2.5em" />
                        </Flex>
                        <Text w="100%" textAlign={"center"} mt={3} fontSize={"lg"} fontWeight={"semibold"}>Relatório Anual</Text>
                        <Text w="100%" textAlign={"center"} mt={1} fontSize={"xs"} color="whiteAlpha.800">Temperaturas ao longo do ano</Text>
                    </Box>
                </Link>
                <Link to={!user.membership ? "/members/account" : "/members/reports/rain/year"}>
                    <Box
                        p={6}
                        bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                        borderRadius="xl"
                        color="white"
                        opacity={!user.membership ? 0.5 : 1}
                        boxShadow="lg"
                        transition="all 0.25s ease"
                        _hover={{ transform: "translateY(-4px)", boxShadow: "xl" }}
                        h="100%"
                    >
                        <Flex justifyContent={"center"} w="100%">
                            <Icon as={!user.membership ? TbLock : TbCloudRain} boxSize="2.5em" />
                        </Flex>
                        <Text w="100%" textAlign={"center"} mt={3} fontSize={"lg"} fontWeight={"semibold"}>Chuva Mensal</Text>
                        <Text w="100%" textAlign={"center"} mt={1} fontSize={"xs"} color="whiteAlpha.800">Precipitação acumulada por mês</Text>
                    </Box>
                </Link>
                <Link to={!user.membership ? "/members/account" : "/members/notices"}>
                    <Box
                        p={6}
                        bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                        borderRadius="xl"
                        color="white"
                        opacity={!user.membership ? 0.5 : 1}
                        boxShadow="lg"
                        transition="all 0.25s ease"
                        _hover={{ transform: "translateY(-4px)", boxShadow: "xl" }}
                        h="100%"
                    >
                        <Flex justifyContent={"center"} w="100%">
                            <Icon as={!user.membership ? TbLock : TbBell} boxSize="2.5em" />
                        </Flex>
                        <Text w="100%" textAlign={"center"} mt={3} fontSize={"lg"} fontWeight={"semibold"}>Alertas</Text>
                        <Text w="100%" textAlign={"center"} mt={1} fontSize={"xs"} color="whiteAlpha.800">Notificações por e-mail/WhatsApp</Text>
                    </Box>
                </Link>
                <Link to={!user.membership ? "/members/account" : "/members/reports/balanco-hidrico"}>
                    <Box
                        p={6}
                        bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                        borderRadius="xl"
                        color="white"
                        opacity={!user.membership ? 0.5 : 1}
                        boxShadow="lg"
                        transition="all 0.25s ease"
                        _hover={{ transform: "translateY(-4px)", boxShadow: "xl" }}
                        h="100%"
                    >
                        <Flex justifyContent={"center"} w="100%">
                            <Icon as={!user.membership ? TbLock : TbPlant} boxSize="2.5em" />
                        </Flex>
                        <Text w="100%" textAlign={"center"} mt={3} fontSize={"lg"} fontWeight={"semibold"}>Balanço Hídrico</Text>
                        <Text w="100%" textAlign={"center"} mt={1} fontSize={"xs"} color="whiteAlpha.800">Gestão de irrigação agrícola</Text>
                    </Box>
                </Link>
                <Link to={!user.membership ? "/members/account" : "/members/admin/heatmap"}>
                    <Box
                        p={6}
                        bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                        borderRadius="xl"
                        color="white"
                        opacity={!user.membership ? 0.5 : 1}
                        boxShadow="lg"
                        transition="all 0.25s ease"
                        _hover={{ transform: "translateY(-4px)", boxShadow: "xl" }}
                        h="100%"
                    >
                        <Flex justifyContent={"center"} w="100%">
                            <Icon as={!user.membership ? TbLock : TbFlame} boxSize="2.5em" />
                        </Flex>
                        <Text w="100%" textAlign={"center"} mt={3} fontSize={"lg"} fontWeight={"semibold"}>Mapa de Calor</Text>
                        <Text w="100%" textAlign={"center"} mt={1} fontSize={"xs"} color="whiteAlpha.800">Visualização climática regional</Text>
                    </Box>
                </Link>
                <Link to="/members/account">
                    <Box
                        p={6}
                        bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                        borderRadius="xl"
                        color="white"
                        boxShadow="lg"
                        transition="all 0.25s ease"
                        _hover={{ transform: "translateY(-4px)", boxShadow: "xl" }}
                        h="100%"
                    >
                        <Flex justifyContent={"center"} w="100%">
                            <Icon as={TbReceipt} boxSize="2.5em" />
                        </Flex>
                        <Text w="100%" textAlign={"center"} mt={3} fontSize={"lg"} fontWeight={"semibold"}>Minha Conta</Text>
                        <Text w="100%" textAlign={"center"} mt={1} fontSize={"xs"} color="whiteAlpha.800">Assinatura e configurações</Text>
                    </Box>
                </Link>
                <Link to="/">
                    <Box
                        p={6}
                        bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                        borderRadius="xl"
                        color="white"
                        boxShadow="lg"
                        transition="all 0.25s ease"
                        _hover={{ transform: "translateY(-4px)", boxShadow: "xl" }}
                        h="100%"
                    >
                        <Flex justifyContent={"center"} w="100%">
                            <Icon as={TbMap} boxSize="2.5em" />
                        </Flex>
                        <Text w="100%" textAlign={"center"} mt={3} fontSize={"lg"} fontWeight={"semibold"}>Mapa</Text>
                        <Text w="100%" textAlign={"center"} mt={1} fontSize={"xs"} color="whiteAlpha.800">Ver todas as estações</Text>
                    </Box>
                </Link>
            </SimpleGrid>
        </Box>
    );
}

export default MemberHome;
